import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

import {
  Typography,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  MenuItem,
  Select,
  Grid,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
  TextField,
  Popper,
} from "@mui/material";

import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";

import { getPayrollSetting } from "../../../../../../actions/paytypes";

import RoundOne from "./one-round";
//Translator TH-EN
import { useTranslation } from "react-i18next";

const StyledDividerDashed = styled(Divider)({
  margin: "16px 0px",
  borderWidth: "0px 0px thin",
  borderColor: "rgba(145, 158, 171, 0.24)",
  borderStyle: "dashed",
  width: "100%",
});

const StyledDivider = styled(Divider)({
  margin: "16px 0px",
  borderWidth: "0px 0px thin",
  borderColor: "rgba(145, 158, 171, 0.24)",
  width: "100%",
});

const StyledAutocomplete = styled(Autocomplete)({
  width: "200px",
  marginBottom: 16,
  border: 0,
  "& .MuiOutlinedInput-root": {
    height: 50,
    padding: "0px 12px",
    borderRadius: 8,
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiButtonBase-root": {
        fontSize: 14,
        width: 22,
        height: 22,
      },
    },
  },
  "& .MuiFilledInput-root": {
    backgroundColor: "#919eab14",
    height: 56,
    padding: "0px 12px",
    borderRadius: 8,
    "&.Mui-focused": {
      backgroundColor: "#919eab14",
    },
    "& .MuiInputAdornment-root": {
      width: 32,
      marginTop: "0!important",
      fontSize: 24,
      color: "#919EAB",
      "& i": {
        marginRight: 8,
      },
    },
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiButtonBase-root": {
        fontSize: 14,
        width: 22,
        height: 22,
      },
    },
    "&:hover": {
      backgroundColor: "#919eab29",
      "&:before": {
        border: "none !important",
      },
    },
    "&::after": {
      border: "none",
    },
    "&::before": {
      border: "none",
    },
  },
});

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    [`& .${autocompleteClasses.option}`]: {
      padding: "8px 16px",
      margin: "0 8px",
      borderRadius: 8,
    },
    [`& .${autocompleteClasses.groupLabel}`]: {
      lineHeight: "32px",
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const GeneralPanel = (props) => {
  const dispatch = useDispatch();
  const { selectedCompany } = props;
  const { t, i18n } = useTranslation();

  const options = [
    { id: 2, label: `ประเภท ${t("Monthly")}` },
    { id: 1, label: `ประเภท ${t("Daily")}` },
  ];

  const [valueTab, setValueTab] = useState("one");
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const [selectedPaymentType, setSelectedPaymentType] = useState(options[0]);

  const { result: payrollSetting } = useSelector(
    (state) => state.payrollSetting
  );

  const [dataForm, setDataForm] = useState(null);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  useEffect(() => {
    if (payrollSetting) {
      let temp = { ...payrollSetting };
      temp.settingYear = dayjs().format("YYYY");
      console.log("temp: ", temp);
      if (temp.paymentTypeRound.length > 0) {
        temp.paymentRound = "1";
      }
      setDataForm(temp);
    }
  }, [payrollSetting]);

  const handleChangeData = (event) => {
    const { name, value } = event.target;
    setDataForm({ ...dataForm, [name]: value });
  };

  useEffect(() => {
    if (payrollSetting) {
      let temp = { ...payrollSetting };
      temp.settingYear = dayjs().format("YYYY");
      if (temp.paymentTypeRound.length > 0) {
        temp.paymentRound = "1";
      }
      setDataForm(temp);
    }
  }, [selectedPaymentType]);

  return (
    <Box>
      {dataForm && (
        <Fragment>
          <Box style={{ marginRight: 16 }}>
            <StyledAutocomplete
              options={options}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" placeholder={""} />
              )}
              value={selectedPaymentType}
              onChange={(event, newValue) => {
                setSelectedPaymentType(newValue);
                dispatch(
                  getPayrollSetting({
                    idCompany: selectedCompany.idCompany,
                    yearSetting: dayjs().format("YYYY"),
                    paymentType: newValue.id,
                  })
                );
              }}
              noOptionsText={t("NoData")}
              disableClearable
              popupIcon={<i class="fa-light fa-chevron-down"></i>}
              PopperComponent={StyledPopper}
            />
          </Box>
          <Box style={{ marginLeft: 16 }}>
            <Typography style={{ fontWeight: 600 }} variant="body1">
              {`${t("PaymentRound")}`}
            </Typography>
            <div className="wrap-item-data">
              <FormControl>
                <RadioGroup
                  readOnly
                  row
                  aria-labelledby="round-payroll"
                  name="paymentRound"
                  value={dataForm.paymentRound}
                  onChange={handleChangeData}
                >
                  <FormControlLabel value="1" control={<Radio />} label={`1`} />
                  <FormControlLabel
                    value="2"
                    control={
                      <Radio
                        disabled={
                          dataForm.paymentTypeRound
                            ? dataForm.paymentTypeRound.length < 2
                            : true
                        }
                      />
                    }
                    label={`2`}
                  />
                  <FormControlLabel
                    value="3"
                    control={<Radio disabled />}
                    label={`3`}
                  />
                  <FormControlLabel
                    value="4"
                    control={<Radio disabled />}
                    label={`4`}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </Box>
          <StyledDivider />
          <Box>
            <RoundOne
              selectedPaymentType={selectedPaymentType}
              dataForm={dataForm}
              handleOnChangeData={handleChangeData}
            />
          </Box>
        </Fragment>
      )}
    </Box>
  );
};

export default GeneralPanel;
